// Intercom-style miniature screen glyphs for outbound config options.
// Each glyph literally depicts where/how the content appears on screen,
// so the option's effect is readable at a glance.

interface GlyphProps {
  className?: string
}

function GlyphSvg({ className, children }: GlyphProps & { children: React.ReactNode }) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      {children}
    </svg>
  )
}

function ScreenFrame() {
  return (
    <rect
      x="1.5"
      y="2"
      width="13"
      height="12"
      rx="2"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  )
}

// Small post: compact card at the bottom of the screen
export function SmallPostGlyph({ className }: GlyphProps) {
  return (
    <GlyphSvg className={className}>
      <ScreenFrame />
      <rect x="4" y="9" width="6.5" height="2.75" rx="1" fill="currentColor" />
    </GlyphSvg>
  )
}

// Large post: panel covering most of the screen
export function LargePostGlyph({ className }: GlyphProps) {
  return (
    <GlyphSvg className={className}>
      <ScreenFrame />
      <rect x="4" y="6" width="9" height="5.75" rx="1" fill="currentColor" />
    </GlyphSvg>
  )
}

// Badge: launcher with a notification dot
export function BadgeGlyph({ className }: GlyphProps) {
  return (
    <GlyphSvg className={className}>
      <rect
        x="2.5"
        y="4.5"
        width="8.5"
        height="8.5"
        rx="2.5"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <circle cx="12.25" cy="4" r="2.5" fill="currentColor" />
    </GlyphSvg>
  )
}

// Snippet: one-line preview strip at the bottom of the screen
export function SnippetGlyph({ className }: GlyphProps) {
  return (
    <GlyphSvg className={className}>
      <ScreenFrame />
      <rect x="4" y="9.5" width="9" height="2.25" rx="1" fill="currentColor" />
    </GlyphSvg>
  )
}

// Full message: content fills the whole screen
export function FullMessageGlyph({ className }: GlyphProps) {
  return (
    <GlyphSvg className={className}>
      <ScreenFrame />
      <rect x="4" y="4.5" width="9" height="7.25" rx="1" fill="currentColor" />
    </GlyphSvg>
  )
}
